import axios from 'axios';
import { ACCOUNT, IS_CLIENT, USER_CODE_ERROR } from '../../client/constants';

const userCodeRegExp: RegExp = /[B-DF-HJ-NP-TV-XZ]{4}[-][B-DF-HJ-NP-TV-XZ]{4}/;

export const sendUserCode = async (
  inputValue: string,
  eventDeviceActivation: string,
  callback: (success: boolean, errorMessage?: string) => void
): Promise<void> => {
  const userCode = `${inputValue.slice(0, 4)}-${inputValue.slice(4)}`;
  if (!userCodeRegExp.test(userCode)) return callback(false, USER_CODE_ERROR.NOT_FOUND);

  const token: string | null = localStorage.getItem(ACCOUNT.AUTH_TOKEN);
  if (!token) return callback(false, USER_CODE_ERROR.LOGGED_OUT);

  try {
    await axios.post(
      eventDeviceActivation,
      { user_code: userCode },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    return callback(true);
  } catch (e: any) {
    if (IS_CLIENT && window.newrelic) {
      window.newrelic.noticeError(new Error('DeviceAuthenticationError'), {
        status_code: e.response?.status
      });
    }
    const error = e.response?.data?.error || e.message;

    return callback(false, error);
  }
};
